<template>
  <AccordBlock>
    <template slot="header">
      <div
          v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
          'ex_sendFrom',
        ])"></div>
        {{ $t('ex_sendFrom.localization_value.value') }}
      </div>
    </template>
    <template slot="body">
      <PickupInfo
          :ex="ex"
          :isEdit="isEdit"
      />
    </template>
  </AccordBlock>
</template>

<script>
import AccordBlock from "@/components/coreComponents/AccordBlock/AccordBlock";
import PickupInfo from "@/components/modules/ExpressOrdersModule/components/chunks/UserBlocks/PickupInfo/PickupInfo";

export default {
  name: "PikupInfoWrap",
  components: {PickupInfo, AccordBlock},

  props: {
    ex: Object,
    isEdit: {
      type: Boolean,
      default: false,
    },
  },

}
</script>

<style scoped>

</style>